export const triggerAssociatedProductsModal = (
  productIds: string | undefined,
  data: any,
  analyticsEventData?: {
    item_list_id: string;
    item_list_name: string;
    event_location: string;
  },
) => {
  window.dispatchEvent(
    new CustomEvent('open-associated-finishes-products-modal', {
      detail: {
        associatedProducts: productIds,
        parentProduct: data,
        analyticsEventData,
      },
    }),
  );
};
